export interface FileRequest {
  guid: string;
  responseType: string;
}
